import {UserAlertsError} from './UserAlertsError.js'

export class UpdateUserAlertsError extends UserAlertsError {
  constructor({message, response}) {
    super(message)
    this._response = response
    this._fieldError = response.data?.errors?.[0]
  }

  getError = () => {
    return this._fieldError ? this._fieldError : this._response
  }
}
